import FilterIcon from '@/components/Icon/FilterIcon'
import type { Category } from '@/types'
import { Fragment, useMemo } from 'react'
import CategoryProductFilterItem from './CategoryProductFilterItem'

interface CategoryProductFiltersProps {
  categoryDetail: Category
}
const CategoryProductFilters = ({
  categoryDetail,
}: CategoryProductFiltersProps) => {
  const renderFilters = useMemo(
    () =>
      categoryDetail.properties
        .filter(x => !x.quickFilter && x.values?.length)
        .sort((a, b) => (a.order || 0) - (b.order || 0)),
    [categoryDetail.properties]
  )

  return (
    <div className='py-5'>
      <h2 className='flex items-center gap-4 px-3 text-lg font-bold text-main'>
        <FilterIcon /> <span>Bộ lọc tìm kiếm</span>
      </h2>
      <hr className='my-4 h-[1px] w-full bg-[#E4E4E4]' />
      {renderFilters.map((filter, i) => (
        <Fragment key={filter._id}>
          {i !== 0 && <hr className='my-4 h-[1px] w-full bg-[#E4E4E4]' />}
          <CategoryProductFilterItem filter={filter} defaultOpen={i < 6} />
        </Fragment>
      ))}
    </div>
  )
}

export default CategoryProductFilters
